import { Box } from "@mui/material";
import {
    MaterialReactTable,
    MRT_ToggleDensePaddingButton,
    MRT_ToggleFiltersButton,
    MRT_ToggleFullScreenButton,
    useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { tableConfig } from "../../../commons/table/config/tableConfig";
import TitleContainer from "../../../commons/table/utilsTable/titleWithFetchData";

const NotificacionHistorialTable = ({ data, loading, fetchData }) => {
    const columns = useMemo(
        () => [
            {
                header: "ART",
                accessorFn: (row) => row.art || "-",
                id: "art",
            },
            {
                header: "Prestador",
                accessorFn: (row) => row.prestador || "-",
                id: "prestador",
            },
            {
                header: "Tipo de Gestion",
                accessorFn: (row) => row.tipoGestion || row.categoria || "-",
                id: "tipoGestion",
            },
            {
                header: "Mensaje",
                accessorFn: (row) => row.titulo || row.nombre || "-",
                id: "titulo",
            },
            {
                header: "Descripcion",
                accessorKey: "descripcion",
            },
            {
                header: "Email Referente",
                accessorFn: (row) => row.emailReferente || "-",
                id: "emailReferente",
            },
            {
                header: "Email Prestador",
                accessorFn: (row) => row.emailPrestador || "-",
                id: "emailPrestador",
            },
            {
                header: "Fecha",
                accessorFn: (row) => row.fechaHoraCreacion || "",
                id: "fechaHoraCreacion",
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    if (!value) {
                        return "-";
                    }

                    return new Date(value).toLocaleString("es-AR");
                },
            },
        ],
        [],
    );

    const table = useMaterialReactTable({
        ...tableConfig,
        columns,
        data: data || [],
        state: { isLoading: loading },
        renderTopToolbarCustomActions: () => (
            <Box m={0.5}>
                <TitleContainer title="Historial de Comunicaciones" fetchData={fetchData} />
            </Box>
        ),
        renderToolbarInternalActions: ({ table }) => (
            <>
                <MRT_ToggleFiltersButton table={table} />
                <MRT_ToggleDensePaddingButton table={table} />
                <MRT_ToggleFullScreenButton table={table} />
            </>
        ),
        layoutMode: "grid",
    });

    return <MaterialReactTable table={table} />;
};

export default NotificacionHistorialTable;
